import { BASE_URL } from "../constants/Endpoints"
import axios from "axios";
import { setLogin, setUserToken, deleteLogin } from '../constants/localStorageFunctions';
import { warningToast } from '../constants/Toasts-Components';

import {
  BrowserRouter as router,
  Switch,
  Route,
  Link
} from "react-router-dom";


axios.interceptors.request.use(

  config => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers['Authorization'] = 'Token ' + token
    }
    return config
  },
  error => {
    Promise.reject(error)
  }

)


axios.interceptors.response.use(
  response => {
    return response
  },
  function (error) {

    //console.log("Inside Reponse intercepter")
    const originalRequest = error.config
    console.log(error);
    console.log(error.response?.status);
    console.log(error.response?.status === 401);

    if (error.response?.status === 401) {
      console.log("Unauthorized request - Session expired");
      
      // Check if we're not already on the login page to avoid redirect loops
      const isOnLoginPage = window.location.pathname.includes('/auth/sign-in');
      
      if (!isOnLoginPage) {
        // Clear authentication data
        deleteLogin();
        
        // Show warning to user
        warningToast('Your session has expired. Please login again.');
        
        // Redirect to login page after a short delay to allow toast to display
        setTimeout(() => {
          window.location.href = '/auth/sign-in';
        }, 1000);
      }
    }

    return Promise.reject(error)
  }
)

export const loginUser = async (formData) =>{
   var form_data = new FormData();
    form_data.append("email",formData.email)
    form_data.append("password",formData.password)

    const response = await axios({
        method: "post",
        url: `${BASE_URL}/api-token-auth/`,
        data: form_data,
        //withCredentials: true
      }).then((response)=>response)
      .catch((error)=>error);  

    return response;

}

export const logout = async () => {
    const response = await axios({
        method: "post",
        url: `${BASE_URL}/auth/sign-out`,
    }).then((response) => response)
    .catch((error) => error);
    return response;
}


export const getAppConfig = async () =>{

   const response = await axios({
       method: "get",
       url: `${BASE_URL}/app-config`,
       //withCredentials: true
     }).then((response)=>response)
     .catch((error)=>error);  

   console.log(response);
   return response;

}




